import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/Home.vue'),
    meta: {
      title: '绵阳市网上房地产超市'
    }
  },
  {
    path: '/district/:id',
    name: 'district',
    component: () => import('../views/District.vue'),
    meta: {
      title: ''
    }
  },
  {
    path: '/exhibitor/:id',
    name: 'exhibitor',
    component: () => import('../views/Exhibitor.vue'),
    meta: {
      title: ''
    }
  },
  {
    path: '/policy',
    name: 'policy',
    component: () => import('../views/Policy.vue'),
    meta: {
      title: '惠民政策'
    }
  }
]

const router = createRouter({
  history: createWebHashHistory(import.meta.env.BASE_URL), // 用 hash 路由
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 如果有保存的位置，则使用保存的位置
    if (savedPosition) {
      return savedPosition
    }
    // 否则滚动到顶部
    return { top: 0 }
  }
})

// 全局路由守卫
router.beforeEach((to, from, next) => {
  // 如果是区县页面，需要动态设置标题
  if (to.name === 'district') {
    const districtId = Number(to.params.id)
    const districtMap = {
      30: '涪城',
      31: '游仙',
      32: '安州',
      33: '高新区',
      34: '经开区',
      35: '科新区',
      36: '仙海',
      37: '江油',
      38: '北川',
      39: '平武',
      40: '三台',
      41: '盐亭',
      42: '梓潼'
    }
    const districtName = districtMap[districtId] || ''
    document.title = `${districtName}在售房源`
  } else {
    // 其他页面直接使用路由配置中的标题
    document.title = to.meta.title || ''
  }
  console.log('路由切换:', from.path, '->', to.path)
  next()
})

export default router 